// extracted by mini-css-extract-plugin
module.exports = {"path":"progress_path__1AKh7","trail":"progress_trail___Miz7","text":"progress_text__2a6Un"};